// Vendor libraries
import { ChangeDetectorRef, EventEmitter } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import { formatDate } from '@angular/common';
// Constants
import { FUND_CHART_SYSTEM_DEFAULT_STATE } from 'ChartApp/ts/features/fundamental-chart/constants';
// Services
import { FundChartService } from 'ChartApp/ts/services/fund-chart.service';
import { ChartZoomService } from 'ChartApp/ts/features/charts-shared/services/chart-zoom.service';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/services/fund-chart.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i4 from "../../../../../../../../charts/static/charts/ts/features/fundamental-chart/components/fundamental-chart.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../features/stress-test-edit-modal/stress-test-edit-modal.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
function StressTestChartComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18)(2, "div", 19)(3, "div", 20)(4, "ycn-fundamental-chart", 21);
    i0.ɵɵlistener("click", function StressTestChartComponent_div_13_Template_ycn_fundamental_chart_click_4_listener() { i0.ɵɵrestoreView(_r4); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.goToFundChartTab()); })("chartDataHandler", function StressTestChartComponent_div_13_Template_ycn_fundamental_chart_chartDataHandler_4_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.chartDataHandler($event)); });
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("noDataClass", ctx_r4.noDataClass)("configurableOptions", ctx_r4.configurableOptions)("chartOptions", ctx_r4.chartOptions)("chartDataUrl", ctx_r4.chartDataUrl);
} }
function StressTestChartComponent_div_14_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 30);
} if (rf & 2) {
    const label_r6 = ctx.$implicit;
    i0.ɵɵproperty("textContent", label_r6);
} }
function StressTestChartComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 18)(2, "div", 19)(3, "div", 23)(4, "div", 24);
    i0.ɵɵelement(5, "div", 25)(6, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 26);
    i0.ɵɵtext(8, "No data available");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 27);
    i0.ɵɵelement(10, "div", 28);
    i0.ɵɵtemplate(11, StressTestChartComponent_div_14_div_11_Template, 1, 1, "div", 29);
    i0.ɵɵelement(12, "div", 28);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("textContent", ctx_r4.startDate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r4.endDate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r4.yAxisLabelsForChartHasNoData[ctx_r4.format]);
} }
export class StressTestChartComponent {
    constructor(changeDetector, fundChartService) {
        this.changeDetector = changeDetector;
        this.fundChartService = fundChartService;
        this.deleteStressTestHandler = new EventEmitter();
        this.loadingChart = true;
        this.noDataClass = 'get-started-small';
        this.yAxisLabelsForChartHasNoData = {
            real: ['6000', '4000', '2000'],
            indexed: ['6.00%', '4.00%', '2.00%'],
            currency_growth: ['$6.00K', '$4.00K', '$2.00K'],
        };
        this.state = cloneDeep(FUND_CHART_SYSTEM_DEFAULT_STATE);
        this.configurableOptions = {
            dynamicHeight: false,
            showLatestValueLabels: true,
            tooltipStyle: 'box',
            yAxisWidth: 48,
            tooltipCallback: (data) => data,
        };
        this.chartOptions = {};
    }
    ngOnInit() {
        this.state.format = this.format;
        this.state.startDate = this.stressTest.startDate;
        this.startDate = formatDate(this.state.startDate, "MMM ''yy", 'en-US', 'UTC');
        if (this.stressTest.endDate) {
            this.state.endDate = this.stressTest.endDate;
            this.endDate = formatDate(this.state.endDate, "MMM ''yy", 'en-US', 'UTC');
        }
        this.state.securities = this.stressTest.securities;
        this.state.zoom = '';
        this.state.calcs = this.calcs;
        this.state.lineAnnotations = this.stressTest.lineAnnotations;
        this.confirmDeleteText = `Are you sure you want to delete the ${this.stressTest.name} stress test?`;
        this.chartHasNoData = !this.state.securities.length;
        this.stressTestToUpdate = {
            id: this.stressTest.id,
            order: this.stressTest.order,
            name: this.stressTest.shortName,
            start_date: this.stressTest.startDate,
            end_date: this.stressTest.endDate,
        };
        this.setChartDataUrls();
    }
    setChartDataUrls() {
        this.chartDataUrl = this.fundChartService.getChartDataUrl(this.state);
    }
    chartDataHandler(chartData) {
        this.loadingChart = !(chartData && Array.isArray(chartData.chart_data) && chartData.chart_data.length > 0);
        // Manually detect changes here
        this.changeDetector.detectChanges();
    }
    goToFundChartTab() {
        const queryParams = this.fundChartService.getChartDataUrlQuery(this.state);
        window.location.href = `${this.chartTabUrl}#/?${queryParams}`;
    }
    editStressTestHandler() {
        window.location.reload();
    }
    confirmDeleteHandler(confirmed) {
        if (confirmed)
            this.deleteStressTestHandler.emit();
    }
}
StressTestChartComponent.ɵfac = function StressTestChartComponent_Factory(t) { return new (t || StressTestChartComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.FundChartService)); };
StressTestChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StressTestChartComponent, selectors: [["ycn-stress-test-chart"]], inputs: { stressTest: "stressTest", format: "format", calcs: "calcs", chartTabUrl: "chartTabUrl" }, outputs: { deleteStressTestHandler: "deleteStressTestHandler" }, features: [i0.ɵɵProvidersFeature([ChartZoomService])], decls: 19, vars: 16, consts: [["confirmDeleteModal", ""], ["editModal", ""], [1, "panel", "panel-data", "panel-multichart"], [1, "panel-header"], [1, "panel-title", 3, "textContent"], [1, "panel-actions"], [1, "panel-action"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-move", 3, "tooltipTitle", "tooltipPlacement"], ["ycnIcon", "", 3, "name"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", 3, "click", "tooltipTitle", "tooltipPlacement"], ["data-test-id", "Delete Icon", "ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", 3, "click", "tooltipTitle", "tooltipPlacement"], [1, "panel-content"], [1, "chart-cover"], ["class", "chart-interactive", "data-test-id", "chart", 4, "ngIf"], ["class", "chart-interactive empty", "data-test-id", "no-chart", 4, "ngIf"], [3, "confirmHandler", "confirmHeader", "confirmText", "confirmButtonText"], [3, "submitModalHandler", "stressTest"], ["data-test-id", "chart", 1, "chart-interactive"], [1, "chart-item"], [1, "chart-wrap"], [1, "chart-canvas"], [1, "chart-canvas", "d-flex", "flex-column", 3, "click", "chartDataHandler", "noDataClass", "configurableOptions", "chartOptions", "chartDataUrl"], ["data-test-id", "no-chart", 1, "chart-interactive", "empty"], [1, "chart-canvas", 2, "height", "193px"], [1, "chart-axis-x"], [1, "chart-axis-x-item", 3, "textContent"], [1, "panel-data-empty-message"], [1, "chart-axis-y"], [1, "chart-axis-y-item"], ["class", "chart-axis-y-item", 3, "textContent", 4, "ngFor", "ngForOf"], [1, "chart-axis-y-item", 3, "textContent"]], template: function StressTestChartComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
        i0.ɵɵelement(2, "h3", 4);
        i0.ɵɵelementStart(3, "div", 5)(4, "div", 6)(5, "div", 7);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(6, "svg", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(7, "div", 9);
        i0.ɵɵlistener("click", function StressTestChartComponent_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r1); const editModal_r2 = i0.ɵɵreference(18); return i0.ɵɵresetView(editModal_r2.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(8, "svg", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(9, "div", 10);
        i0.ɵɵlistener("click", function StressTestChartComponent_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r1); const confirmDeleteModal_r3 = i0.ɵɵreference(16); return i0.ɵɵresetView(confirmDeleteModal_r3.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(10, "svg", 8);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(11, "div", 11)(12, "div", 12);
        i0.ɵɵtemplate(13, StressTestChartComponent_div_13_Template, 5, 4, "div", 13)(14, StressTestChartComponent_div_14_Template, 13, 3, "div", 14);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(15, "ycn-confirm-modal", 15, 0);
        i0.ɵɵlistener("confirmHandler", function StressTestChartComponent_Template_ycn_confirm_modal_confirmHandler_15_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.confirmDeleteHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "ycn-stress-test-edit-modal", 16, 1);
        i0.ɵɵlistener("submitModalHandler", function StressTestChartComponent_Template_ycn_stress_test_edit_modal_submitModalHandler_17_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.editStressTestHandler()); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("textContent", ctx.stressTest.name);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("tooltipTitle", "Reorder")("tooltipPlacement", "top");
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-move");
        i0.ɵɵadvance();
        i0.ɵɵproperty("tooltipTitle", "Edit")("tooltipPlacement", "top");
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-edit");
        i0.ɵɵadvance();
        i0.ɵɵproperty("tooltipTitle", "Delete")("tooltipPlacement", "top");
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-delete");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.chartHasNoData);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.chartHasNoData);
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmHeader", "Delete Stress Test")("confirmText", ctx.confirmDeleteText)("confirmButtonText", "OK");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("stressTest", ctx.stressTestToUpdate);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i3.ConfirmModalComponent, i4.FundamentalChartComponent, i5.IconDirective, i6.StressTestEditModalComponent, i7.TooltipDirective], encapsulation: 2 });
